import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import { ManagerAuthorization } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import { hasOneAuthorization } from '@frontend/utils';
import type { DeclarationActivity } from '../../declarationActivities/declarationActivity';

type ServiceDeclarationActivityListTableProps = {
    items: DeclarationActivity[];
    onEdit: (id: string) => void;
    onRemove: (id: string) => void;
};

export function ServiceDeclarationActivityListTable({
    items,
    onEdit,
    onRemove,
}: ServiceDeclarationActivityListTableProps) {
    const canAddEdit = hasOneAuthorization(ManagerAuthorization.serviceAddEdit);

    const {
        serviceDeclarationActivities: { codeActiviteit, activityType, codeSpecialisme },
    } = getSelectedLanguage();

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeader>{codeActiviteit}</TableHeader>
                        <TableHeader>{activityType}</TableHeader>
                        <TableHeader>{codeSpecialisme}</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map((serviceDeclarationActivity) => (
                        <TableRow key={serviceDeclarationActivity.id}>
                            <TableCell>{serviceDeclarationActivity.codeActiviteit}</TableCell>
                            <TableCell>{serviceDeclarationActivity.activityType}</TableCell>
                            <TableCell>{serviceDeclarationActivity.codeSpecialisme}</TableCell>
                            <TableCell>
                                {canAddEdit && (
                                    <>
                                        <IconButton
                                            icon="edit"
                                            labelText="Edit"
                                            onClick={() => onEdit(serviceDeclarationActivity.id)}
                                        />
                                        <IconButton
                                            icon="delete"
                                            onClick={() => onRemove(serviceDeclarationActivity.id)}
                                        />
                                    </>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
